import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionLabel } from './ui/SectionLabel';
import { CtaButton } from './ui/CtaButton';
const includes = ['120 Ready-to-Teach Classes', '6 Professional Volumes', '5 Premium Bonuses', 'Instant Digital Access'];
export function OfferSection() {
  return <section id="offer" className="w-full bg-ivory py-10 sm:py-14 lg:py-18" aria-labelledby="offer-heading" data-id="element-149" data-mp="df6tw7y1h3je">
      <div className="mx-auto w-full max-w-xl px-5 sm:px-8" data-id="element-150" data-mp="icym732liro4">
        <div className="rounded-[2rem] border border-gold/50 bg-cream p-1.5 shadow-card" data-id="element-151" data-mp="me1xdc9p7zj0">
          <div className="rounded-[1.7rem] border border-gold/25 bg-ivory px-5 py-7 text-center sm:px-8 sm:py-9" data-id="element-152" data-mp="rdmztwo2uq0h">
            <div className="flex justify-center" data-id="element-153" data-mp="wbyag9m754jr">
              <SectionLabel data-id="element-154" data-mp="wan35ztjlenw">The complete offer</SectionLabel>
            </div>

            <h2 id="offer-heading" className="mt-3 font-serif text-[1.35rem] font-semibold uppercase leading-tight text-ink sm:text-3xl" data-id="element-155" data-mp="2t747v1g4dsvr">
              Yoga Teacher System™
            </h2>

            <ul className="mx-auto mt-4 grid max-w-sm gap-1.5" data-id="element-156" data-mp="xx1y7ws1oi50">
              {includes.map(item => <li key={item} className="flex items-center justify-center gap-2.5 rounded-xl bg-cream/70 px-3 py-2.5" data-id="element-157" data-mp="sxfingoqupt1">
                  <span className="flex h-4 w-4 shrink-0 items-center justify-center rounded-full bg-forest" data-id="element-158" data-mp="oual7sjiteb9">
                    <CheckIcon className="h-2.5 w-2.5 text-ivory" aria-hidden="true" data-id="element-159" data-mp="1gn9upw18oac8" />
                  </span>
                  <span className="text-[0.85rem] font-medium leading-snug text-ink sm:text-[0.92rem]" data-id="element-160" data-mp="1clg1u9xacamm">
                    {item}
                  </span>
                </li>)}
            </ul>

            <div className="mt-7 border-t border-gold/25 pt-7" data-id="element-161" data-mp="172hvg5nkfbv">
              <p className="font-serif text-[3.5rem] font-semibold leading-none text-forest sm:text-7xl" data-id="element-162" data-mp="146hzma8vgks">
                $19{' '}
                <span className="align-baseline text-[0.4em] font-semibold uppercase tracking-label text-ink" data-id="element-163" data-mp="3tthq0vop768d">
                  USD
                </span>
              </p>
              <p className="mt-3 text-[0.8rem] leading-snug text-muted sm:text-sm" data-id="element-164" data-mp="3ktbe3e8neebb">
                Pay in your local currency.
              </p>
              <p className="mt-3 flex items-center justify-center gap-2 text-[0.62rem] font-semibold uppercase tracking-label text-ink" data-id="element-165" data-mp="3otv6y5m6uvrn">
                <span className="h-px w-6 bg-gold/50" aria-hidden="true" data-id="element-166" data-mp="3b1f3j3pdkvq7" />
                One-time payment
                <span className="h-px w-6 bg-gold/50" aria-hidden="true" data-id="element-167" data-mp="3fw1i1fqr74ei" />
              </p>

              <div className="mt-6" data-id="element-168" data-mp="313hfag7imyxl">
                <CtaButton href="https://yogateachersystem.impultienda.ar/checkout" label="Get instant access" microcopy="Instant Digital Access • 7-Day Guarantee • No Subscription" data-id="element-169" data-mp="363vlrttgy0ti" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}